import { render, staticRenderFns } from "./physicianVisits.vue?vue&type=template&id=203fc3ae&scoped=true&"
import script from "./physicianVisits.vue?vue&type=script&lang=js&"
export * from "./physicianVisits.vue?vue&type=script&lang=js&"
import style0 from "./physicianVisits.vue?vue&type=style&index=0&id=203fc3ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203fc3ae",
  null
  
)

export default component.exports